import { render, staticRenderFns } from "./gradebook.vue?vue&type=template&id=7812054b&scoped=true"
import script from "./gradebook.vue?vue&type=script&lang=js"
export * from "./gradebook.vue?vue&type=script&lang=js"
import style0 from "./gradebook.vue?vue&type=style&index=0&id=7812054b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7812054b",
  null
  
)

export default component.exports